import Vue from 'vue'
import Router from 'vue-router'
import Finished from './components/GameTabs/Finished'
import Live from './components/GameTabs/Live'
import Today from './components/GameTabs/Today'
import Scheduled from './components/GameTabs/Scheduled'
import MyGames from './components/GameTabs/MyGames'
import AllGames from './components/GameTabs/AllGames'
import LeaguePage from './components/RightColumn/LeaguePage'
import Leagues from './components/RightColumn/Leagues'
import PredictionsList from './components/RightColumn/PredictionsList'
import Leaderboard from './components/RightColumn/Leaderboard'
import LeaguePageGames from './components/RightColumn/LeaguePageGames'
import PlayerPage from './components/LeftColumn/PlayerPage'
import NavbarLinks from './components/MiddleColumn/NavbarLinks'
import MatchPage from './components/MatchPage/MatchPage'
import MatchPagePar from './components/MatchPage/MatchPagePar'
import AllGamesPar from './components/GameTabs/AllGamesPar'
import FinishedPar from './components/GameTabs/FinishedPar'
import validate from './store/games'

Vue.use(Router)

export default new Router ({
    mode: 'hash',
    scrollBehavior () {
        return { x: 0, y: 100 }
      },
    routes: [
            {
            path: '/',
            redirect:'/Today',
            component: NavbarLinks,
            children: [
                {   
                    name: 'AllGamesPar',
                    path:'AllGamesPar',
                    component: AllGamesPar,
                    
                },
                {   
                    name: 'AllGames',
                    path:'AllGames',
                    component: AllGames,
                    
                },
                {
                    name: 'FinishedPar',
                    path:'FinishedPar',
                    component: FinishedPar
                },
                {
                    name: 'Finished',
                    path:'gamesFrom/:dateS',
                    component: Finished
                },
                {
                    name: 'Live',
                    path:'Live',
                    component: Live
                },
                {
                    name: 'Today',
                    path:'Today',
                    component: Today
                },
                {
                    name: 'Scheduled',
                    path:'Scheduled',
                    component: Scheduled
                },
                {
                    name: 'MyGames',
                    path:'MyGames',
                    component: MyGames
                },
                {   
                    name: 'Leagues',
                    path:'Leagues',
                    component: Leagues,
                },
            ],
        },
        {
            name: 'MatchPagePar',
            path: '/MatchPagePar/:gameId',
            component: MatchPagePar,
            beforeEnter: (to, from, next) =>{
                if (validate.state.token.token) {
                    next();
                } else {
                    alert('Log in to see match details!');
                }
            },
        },
        {
            name: 'MatchPage',
            path: '/MatchPage',
            component: MatchPage,
            // children: [
            //     {
            //         name:'MyGames',
            //         path:'MyGames',
            //         component: MyGames,
            //     },
            // ],
        },
        {
            name: 'PredictionsList',
            path: '/PredictionsList',
            component: PredictionsList,
        },
        {
            name: 'Leaderboard',
            path: '/Leaderboard',
            component: Leaderboard,
        },
        {
            name: 'PlayerPage',
            path: '/PlayerPage/:id',
            component: PlayerPage,
        },
        {
            name: 'LeaguePageNav',
            path: '/LeaguePageNav',
            redirect:'LeaguePageNav/LeaguePageGames/:leagueId',
            component: () => import('./components/RightColumn/LeaguePageNav'),
            children:[
                {
                    name: 'LeaguePage',
                    path:'LeaguePage/:leagueId',
                    component: LeaguePage,
                },
                {
                    name: 'LeaguePageGames',
                    path:'LeaguePageGames/:leagueId',
                    component: LeaguePageGames,
                },

            ],
            beforeEnter: (to, from, next) =>{
                if (validate.state.token.token) {
                    next();
                } else {
                    alert('Log in to see tables and results!');
                }
            },
        },
        {
            name: 'teamPage',
            path: '/teamPage/:id',
            component: () => import('./components/Teampage/teamPage'),
            beforeEnter: (to, from, next) =>{
                if (validate.state.token.token) {
                    next();
                } else {
                    alert('Log in to see team details!');
                }
            },
        },
        {
            name: 'teamPagePar',
            path: '/teamPagePar/:id',
            component: () => import('./components/Teampage/teamPagePar'),
        },
        {
            name: 'Profile',
            path: '/Profile',
            component: () => import('./components/profilePage/Profile'),
        },
    ]
})